import * as Scrivito from "scrivito"
import { ScrivitoAttributes } from "shared/types/ScrivitoAttributes"

export const AttributeInformationWrapperObjClass = Scrivito.provideObjClass(
  "AttributeInformationWrapper",
  {
    attributes: {
      title: "string",
      description: "string",
      configurationID: "string",
      attributeInformation: ["reference", { only: "AttributeInformation" }]
    }
  }
)

export type AttributeInformationWrapperObj = InstanceType<
  typeof AttributeInformationWrapperObjClass
>

export type AttributeInformationWrapperAttributes =
  ScrivitoAttributes<AttributeInformationWrapperObj>
